import { z } from "zod";

export const ConsumerResearchSentimentBreakdownSchema = z.object({
  positive: z.number(),
  negative: z.number(),
  neutral: z.number(),
});

export const ConsumerResearchCompetitorVoiceSchema = z.object({
  brand_name: z.string(),
  mention_count: z.number(),
  share_percentage: z.number(),
});

export const ConsumerResearchOverviewStatsSchema = z.object({
  total_mentions: z.number(),
  avg_sentiment: z.number(),
  brand_nps: z.number(),
  share_of_voice: z.number(),
  sentiment_breakdown: ConsumerResearchSentimentBreakdownSchema,
  competitor_voice: z.array(ConsumerResearchCompetitorVoiceSchema),
});
